var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeniorCitizen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2085_57159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8699 11.2793H9.16943V17.7535H14.8699V11.2793Z",
    fill: "#E7A484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 16.2896C10.5749 16.0901 9.73813 15.3379 9.17188 14.2578V13.21L12.0208 13.3704L14.8697 13.21V14.2578C14.3034 15.3379 13.4666 16.0901 12.523 16.2896C12.3933 16.3172 12.261 16.3342 12.1266 16.34C12.125 16.3401 12.1234 16.3401 12.1218 16.3402C12.0541 16.3431 11.9867 16.343 11.9197 16.3402C11.9181 16.3401 11.9166 16.3401 11.915 16.34C11.7806 16.3342 11.6483 16.3172 11.5186 16.2896Z",
    fill: "#A65444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0025 8.45233C16.7217 7.78173 16.1481 8.11187 16.1481 8.11187C16.4805 5.0667 14.9284 3.05664 12.0205 3.05664C9.11254 3.05664 7.56038 5.0667 7.89114 8.11187C7.89114 8.11187 7.31748 7.78345 7.03668 8.45233C6.75588 9.12292 7.26925 10.6928 7.58622 11.1932C7.9032 11.6918 8.4648 11.5749 8.4648 11.5749C8.4648 11.5749 8.50098 12.6306 8.64741 13.0209C8.79384 13.4113 9.81368 15.7583 12.0187 15.7583C14.2238 15.7583 15.2436 13.4113 15.3901 13.0209C15.5365 12.6306 15.5727 11.5319 15.5727 11.5319C15.5727 11.5319 16.1343 11.6935 16.4513 11.1932C16.7682 10.6945 17.2816 9.12292 17.0008 8.45233H17.0025Z",
    fill: "#E7A484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47633 10.7585L8.34766 10.7671L8.40194 11.5786L8.53062 11.57L8.47633 10.7585Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.575 10.7583L15.5137 11.5261L15.6422 11.5364L15.7036 10.7685L15.575 10.7583Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41889 9.96375C7.23319 9.24845 7.26242 8.80999 7.51002 8.5813L7.59771 8.67587C7.39138 8.86673 7.37246 9.27596 7.54441 9.93108L7.41889 9.96375Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.651 9.96375L16.5255 9.93108C16.6957 9.27596 16.6785 8.86501 16.4722 8.67587L16.5599 8.5813C16.8092 8.80999 16.8384 9.24845 16.651 9.96375Z",
    fill: "#C46966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2932 17.6232C17.5605 15.7433 14.8972 15.0774 14.8972 15.0774C13.5309 17.2756 10.3613 17.3077 9.15275 15.0774C9.15275 15.0774 6.48251 15.7433 3.74985 17.6232C-0.764395 20.7289 8.51814 24.7981 12.0224 24.7981C15.5267 24.7981 24.4437 20.9434 20.2949 17.6232H20.2932Z",
    fill: "#E47820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7634 4.42798C7.25201 5.1287 7.68087 7.2801 7.89446 8.13397C8.75761 5.90148 9.65329 5.97409 9.77565 5.12873C8.93028 5.12873 9.16387 4.60593 8.7634 4.42798Z",
    fill: "#C9C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2713 4.42822C16.7827 5.12894 16.3538 7.28034 16.1402 8.13421C15.2771 5.90173 14.3814 5.97434 14.259 5.12897C15.1044 5.12897 14.8708 4.60618 15.2713 4.42822Z",
    fill: "#C9C8C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2085_57159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeniorCitizen);
export default __webpack_public_path__ + "static/media/seniorCitizen.efb794366f0a40276f255414340be8f6.svg";
export { ForwardRef as ReactComponent };